/**
 * Reguły startu lobby — JEDNO miejsce dla całego frontu.
 *
 * Warunek startu był zduplikowany: ekran lobby wymagał w grze z botami co najmniej
 * jednego bota, a zminimalizowany widżet (LobbyStatusWidget) sprawdzał tylko liczbę
 * graczy i dla gry singleplayer nie sprawdzał nic. Dało się więc utworzyć grę z botami,
 * zminimalizować okno, kliknąć „Rozpocznij" i grać całkiem sam, bez przeciwników.
 * Backend pilnuje tego niezależnie (GameSocketHandler), ale reguła klienta ma być jedna.
 */

/** Minimalna liczba uczestników rozgrywki (gracze + boty). */
export const MIN_LOBBY_PARTICIPANTS = 2;

/**
 * Czy host może wystartować lobby.
 * @param {Object} args
 * @param {Boolean} args.isSingleplayer - gra z botami (bez innych ludzi)
 * @param {Array} args.players - lista uczestników lobby ({ isBot })
 * @returns {Boolean}
 */
export function canStartLobby({ isSingleplayer = false, players = [] } = {}) {
  const list = Array.isArray(players) ? players : [];
  if (isSingleplayer) {
    return list.filter(p => p?.isBot).length >= 1;
  }
  return list.length >= MIN_LOBBY_PARTICIPANTS;
}

export default canStartLobby;
